export default __webpack_public_path__ + "static/careers-slide-2-6f419e0d8a842e436c89eec0479128d3.png";